import { PATH, USER_ROLE } from '@/shared/constants';

import IconHome from '@/shared/assets/svg/layout/globalSidebar/icon-home.svg?react';
import IconUsersOutlineDouble from '@/shared/assets/svg/layout/globalSidebar/icon-users-outline-double.svg?react';
import IconUserCircle from '@/shared/assets/svg/layout/globalSidebar/icon-user-circle.svg?react';
import IconMegaphoneOutline from '@/shared/assets/svg/common/icon-megaphone-outline.svg?react';
import IconCheckSquareBroken from '@/shared/assets/svg/layout/globalSidebar/icon-check-square-broken.svg?react';
import IconClassroomThin from '@/shared/assets/svg/layout/globalSidebar/icon-classroom-thin.svg?react';
import IconAdmin from '@/shared/assets/svg/layout/globalSidebar/icon-admin.svg?react';
import IconBook from '@/shared/assets/svg/layout/globalSidebar/icon-book.svg?react';
import IconMessageNotification from '@/shared/assets/svg/layout/globalSidebar/icon-message-notification.svg?react';
import IconMessageText from '@/shared/assets/svg/layout/globalSidebar/icon-message-text.svg?react';
import IconCalendar from '@/shared/assets/svg/common/icon-calendar.svg?react';

import type { BottomNavItem, SidebarMenuItem } from './types';

/** 이 폭 이하에서 모바일 앱 셸(상단바+하단탭바)로 전환한다. MainLayout.tsx의 미디어쿼리와 값을 맞춘다. */
export const MOBILE_BREAKPOINT_PX = 767;
/** PC에서 앱 셸을 보여줄 때의 최대 폭 */
export const MOBILE_SHELL_MAX_WIDTH_PX = 480;

/** 원장 메뉴 */
const adminMenu: SidebarMenuItem[] = [
  {
    id: 'basic-settings',
    Icon: <IconClassroomThin />,
    label: '기초 설정',
    title: '기초 설정',
    path: null,
    expandable: true,
    children: [
      {
        // 활성 제외 규칙은 넓은 쪽(전체 학생)에 건다 — 여기에 상위 prefix를 걸면 자기 자신이 영영 활성이 되지 않는다
        id: 'basic-settings-student-info',
        label: '학생 정보 설정',
        title: '학생 정보 설정',
        path: PATH.ADMIN.STUDENT.SETTING,
      },
      {
        id: 'basic-settings-lesson-info',
        label: '수업 정보 설정',
        title: '수업 정보 설정',
        path: PATH.ADMIN.LESSON.SETTING,
      },
      {
        id: 'basic-settings-staff-info',
        label: '직원 정보 설정',
        title: '직원 정보 설정',
        path: PATH.ADMIN.STAFF.SETTING,
      },
    ],
  },
  {
    id: 'lesson',
    Icon: <IconClassroomThin />,
    label: '수업 운영',
    title: '수업 운영',
    path: null,
    expandable: true,
    children: [
      {
        id: 'lesson-add',
        label: '신규 수업 생성',
        title: '신규 수업 생성',
        path: PATH.ADMIN.LESSON.ADD,
      },
      {
        id: 'lesson-list',
        label: '전체 수업 목록',
        title: '전체 수업 목록',
        path: PATH.ADMIN.LESSON.INDEX,
        excludeActivePaths: [PATH.ADMIN.LESSON.ADD, PATH.ADMIN.LESSON.SETTING],
      },
    ],
  },
  {
    id: 'student',
    Icon: <IconUsersOutlineDouble className='stroke-[1.5]' />,
    label: '학생 관리',
    title: '학생 관리',
    path: null,
    expandable: true,
    children: [
      {
        id: 'student-add',
        label: '신규 학생 등록',
        title: '신규 학생 등록',
        path: PATH.ADMIN.STUDENT.ADD,
      },
      {
        id: 'student-list',
        label: '전체 학생',
        title: '전체 학생',
        path: PATH.ADMIN.STUDENT.INDEX,
        excludeActivePaths: [PATH.ADMIN.STUDENT.ADD, PATH.ADMIN.STUDENT.SETTING],
      },
    ],
  },
  // {
  //   id: 'learning',
  //   Icon: <IconBook className='stroke-[1.5]' />,
  //   label: '학습 관리',
  //   title: '학습 관리',
  //   path: null,
  //   expandable: true,
  //   children: [
  //     {
  //       id: 'learning-vod',
  //       label: 'VOD',
  //       title: 'VOD',
  //       path: null,
  //     },
  //     {
  //       id: 'learning-quiz',
  //       label: '퀴즈',
  //       title: '퀴즈',
  //       path: null,
  //     },
  //     {
  //       id: 'learning-assignment',
  //       label: '과제물',
  //       title: '과제물',
  //       path: null,
  //     },
  //   ],
  // },
  {
    id: 'staff',
    Icon: <IconAdmin className='stroke-[1.5]' />,
    label: '직원 관리',
    title: '직원 관리',
    path: null,
    expandable: true,
    children: [
      {
        id: 'staff-add',
        label: '신규 직원 등록',
        title: '신규 직원 등록',
        path: PATH.ADMIN.STAFF.ADD,
      },
      {
        id: 'staff-list',
        label: '전체 직원 목록',
        title: '전체 직원 목록',
        path: PATH.ADMIN.STAFF.INDEX,
        excludeActivePaths: [PATH.ADMIN.STAFF.ADD, PATH.ADMIN.STAFF.SETTING],
      },
      // {
      //   id: 'staff-org-permission',
      //   label: '조직도/권한 설정',
      //   title: '조직도/권한 설정',
      //   path: null,
      // },
    ],
  },
  {
    id: 'notification-send',
    Icon: <IconMessageNotification className='stroke-[1.5]' />,
    label: '알림 발송',
    title: '알림 발송',
    path: null,
    expandable: true,
    children: [
      {
        id: 'notification-send-email',
        label: '이메일 발송',
        title: '이메일 발송',
        path: null,
      },
    ],
  },
  {
    id: 'notification-settings',
    Icon: <IconMessageNotification className='stroke-[1.5]' />,
    label: '알림 설정',
    title: '알림 설정',
    path: null,
    expandable: true,
    children: [
      {
        id: 'notification-settings-automation',
        label: '알림 자동화 설정',
        title: '알림 자동화 설정',
        path: PATH.ADMIN.NOTIFICATION.AUTOMATION,
      },
      {
        id: 'notification-settings-templates',
        label: '발송 템플릿 관리',
        title: '발송 템플릿 관리',
        path: PATH.ADMIN.NOTIFICATION.TEMPLATES,
      },
    ],
  },
  {
    id: 'instructor',
    Icon: <IconUserCircle className='stroke-[1.5]' />,
    label: '강사 관리',
    title: '강사 관리',
    path: null,
    expandable: true,
    children: [
      {
        id: 'instructor-add',
        label: '신규 강사 등록',
        title: '신규 강사 등록',
        path: PATH.ADMIN.INSTRUCTOR.ADD,
      },
      {
        id: 'instructor-list',
        label: '전체 강사 목록',
        title: '전체 강사 목록',
        path: PATH.ADMIN.INSTRUCTOR.INDEX,
        excludeActivePaths: [PATH.ADMIN.INSTRUCTOR.ADD],
      },
    ],
  },
  {
    id: 'counselings',
    Icon: <IconMessageText className='stroke-[1.5]' />,
    label: '상담 관리',
    title: '상담 관리',
    path: null,
    expandable: true,
    children: [
      {
        id: 'counselings-add',
        label: '상담 추가',
        title: '상담 추가',
        path: PATH.ADMIN.COUNSELING.ADD,
      },
      {
        id: 'counselings-list',
        label: '상담 목록',
        title: '상담 목록',
        path: PATH.ADMIN.COUNSELING.INDEX,
        excludeActivePaths: [PATH.ADMIN.COUNSELING.ADD],
      },
    ],
  },
  {
    id: 'attendance',
    Icon: <IconCheckSquareBroken className='stroke-[1.5]' />,
    label: '출결 관리',
    title: '출결 관리',
    path: null,
    expandable: true,
    children: [
      {
        id: 'attendance-index',
        label: '출결/알림 발송',
        title: '출결/알림 발송',
        path: PATH.ADMIN.ATTENDANCE.INDEX,
        excludeActivePaths: [PATH.ADMIN.ATTENDANCE.ZOOM_ACCOUNT],
      },
      {
        id: 'attendance-zoom-account',
        label: 'zoom 학원 계정',
        title: 'zoom 학원 계정',
        path: PATH.ADMIN.ATTENDANCE.ZOOM_ACCOUNT,
      },
      {
        id: 'attendance-tablet',
        label: '출결 태블릿',
        title: '출결 태블릿',
        path: PATH.PUBLIC.ATTENDANCE_TABLET,
      },
    ],
  },
  {
    id: 'notices',
    Icon: <IconMegaphoneOutline className='stroke-[1.5]' />,
    label: '공지사항',
    title: '공지사항',
    path: PATH.ADMIN.NOTICE.INDEX,
  },
];

/** 강사 메뉴 */
const instructorMenu: SidebarMenuItem[] = [
  { id: 'home', Icon: <IconHome />, label: 'Dashboard', title: 'Dashboard', path: PATH.INSTRUCTOR.HOME },
  {
    id: 'lesson-board',
    Icon: <IconClassroomThin />,
    label: 'My Lesson',
    title: 'My Lesson',
    path: null,
    children: [],
    lazyExpandChildren: true,
    lazyResourceKey: 'expandedLesson',
    activePathPrefix: [PATH.INSTRUCTOR.LESSON.BOARD.INDEX, PATH.INSTRUCTOR.LESSON.DETAIL.INDEX],
  },
  // {
  //   id: 'counseling',
  //   Icon: <IconMessageText className='stroke-[1.5]' />,
  //   label: 'Counseling',
  //   title: 'Counseling',
  //   path: PATH.INSTRUCTOR.COUNSELING.INDEX,
  // },
  {
    id: 'notice',
    Icon: <IconMegaphoneOutline className='stroke-[1.5]' />,
    label: 'Notices',
    title: 'Notices',
    path: PATH.INSTRUCTOR.NOTICE.INDEX,
  },
];

/**
 * 학생 메뉴 (데스크톱 LNB) — student/parent는 capacitor-gate-erp의 라우트 구성을 기준으로 삼기로 해서
 * gate-erp 고유였던 My Lesson/Notices 대신 Home/My Class/Attendance/Assignment/Classroom을 가리키지만,
 * 스타일·컴포넌트는 다른 데스크톱 메뉴(adminMenu 등)와 같은 평범한 LNB 항목이다.
 * subtitle/disabled 같은 모바일 드로어 전용 꾸밈은 여기 안 쓴다 — 그건 MOBILE_MENU_BY_ROLE 쪽 몫.
 */
const studentMenu: SidebarMenuItem[] = [
  { id: 'home', Icon: <IconHome />, label: 'Home', title: 'Home', path: PATH.STUDENT.HOME },
  { id: 'my-class', Icon: <IconCheckSquareBroken />, label: 'My Class', title: 'My Class', path: PATH.STUDENT.MY_CLASS },
  { id: 'attendance', Icon: <IconCalendar />, label: 'Attendance', title: 'Attendance', path: PATH.STUDENT.ATTENDANCE.INDEX },
  { id: 'notice', Icon: <IconMegaphoneOutline />, label: 'Notice', title: 'Notice', path: PATH.STUDENT.NOTICE.INDEX },
  {
    id: 'assignment',
    Icon: <IconBook />,
    label: 'Assignment',
    title: 'Assignment',
    path: null,
    expandable: true,
    children: [
      { id: 'assignment-log', title: 'Assignment Log', path: PATH.STUDENT.ASSIGNMENT.LOG },
      { id: 'assignment-setup', title: 'Assignment Setting', path: PATH.STUDENT.ASSIGNMENT.SETUP },
    ],
  },
  {
    id: 'classroom',
    Icon: <IconCheckSquareBroken />,
    label: 'Classroom',
    title: 'Classroom',
    path: null,
    // 펼칠 때 API로 수업 목록을 채운다 — 실제 children은 _useMainLayoutLogic에서 주입 (ERP 패턴)
    lazyExpandChildren: true,
    lazyResourceKey: 'expandedLesson',
    // 자식 경로(/student/classroom/:lessonId)가 아직 안 채워졌어도 이 prefix로 부모 행을 활성 표시한다
    activePathPrefix: [PATH.STUDENT.CLASSROOM.INDEX],
    children: [],
  },
];

/** 학부모 메뉴 (데스크톱 LNB) — studentMenu와 같은 평범한 스타일로 Home/My Class/Attendance를 가리킨다 */
const parentMenu: SidebarMenuItem[] = [
  { id: 'home', Icon: <IconHome />, label: 'Home', title: 'Home', path: PATH.PARENT.HOME },
  { id: 'my-class', Icon: <IconCheckSquareBroken />, label: 'My Class', title: 'My Class', path: PATH.PARENT.MY_CLASS },
  { id: 'attendance', Icon: <IconCalendar />, label: 'Attendance', title: 'Attendance', path: PATH.PARENT.ATTENDANCE.INDEX },
];

/** 권한별 사이드바 메뉴 */
export const PERMISSION_MENU: Record<string, SidebarMenuItem[]> = {
  [USER_ROLE.ADMIN]: adminMenu,
  [USER_ROLE.STAFF]: adminMenu,
  [USER_ROLE.INSTRUCTOR]: instructorMenu,
  [USER_ROLE.STUDENT]: studentMenu,
  [USER_ROLE.PARENT]: parentMenu,
};

/** 권한에 메뉴가 없을 때 쓰는 빈 배열 — 매 렌더마다 새 배열이 생겨 memo가 깨지는 것을 방지 */
export const EMPTY_MENU: SidebarMenuItem[] = [];

/**
 * 모바일(Capacitor) 셸의 하단 탭바 — student/parent만 대상.
 * capacitor-gate-erp 원안(Home/My Class/Attendance)을 그대로 따른다. Report Card 등 나머지는
 * 탭에서는 빠지지만 URL로는 여전히 접근 가능하다.
 */
export const BOTTOM_NAV_BY_ROLE: Partial<Record<string, BottomNavItem[]>> = {
  [USER_ROLE.STUDENT]: [
    { id: 'home', label: 'Home', Icon: <IconHome />, path: PATH.STUDENT.HOME },
    { id: 'my-class', label: 'My Class', Icon: <IconCalendar />, path: PATH.STUDENT.MY_CLASS },
    { id: 'attendance', label: 'Attendance', Icon: <IconCheckSquareBroken />, path: PATH.STUDENT.ATTENDANCE.INDEX },
  ],
  [USER_ROLE.PARENT]: [
    { id: 'home', label: 'Home', Icon: <IconHome />, path: PATH.PARENT.HOME },
    { id: 'my-class', label: 'My Class', Icon: <IconCalendar />, path: PATH.PARENT.MY_CLASS },
    { id: 'attendance', label: 'Attendance', Icon: <IconCheckSquareBroken />, path: PATH.PARENT.ATTENDANCE.INDEX },
  ],
};

/**
 * 모바일 앱 셸의 드로어(햄버거) 메뉴 — capacitor-gate-erp의 STUDENT_MENU/PARENT_MENU를 그대로 이식.
 * studentMenu/parentMenu(데스크톱 LNB)와 가리키는 라우트는 같지만, subtitle/disabled로
 * 모바일 드로어 전용 꾸밈(강조색, 부가설명, 준비중 흐림 처리)이 붙는다 — 그래서 따로 둔다.
 */
export const MOBILE_MENU_BY_ROLE: Partial<Record<string, SidebarMenuItem[]>> = {
  [USER_ROLE.STUDENT]: [
    { id: 'home', Icon: <IconHome />, label: 'HOME', title: 'HOME', path: PATH.STUDENT.HOME },
    {
      id: 'my-class',
      Icon: <IconCheckSquareBroken />,
      label: 'My Class',
      title: 'My Class',
      subtitle: '(전체수강내역)',
      path: PATH.STUDENT.MY_CLASS,
    },
    { id: 'attendance', Icon: <IconCalendar />, label: 'Attendance', title: 'Attendance', path: PATH.STUDENT.ATTENDANCE.INDEX },
    { id: 'notice', Icon: <IconMegaphoneOutline />, label: 'Notice', title: 'Notice', path: PATH.STUDENT.NOTICE.INDEX },
    {
      id: 'assignment',
      Icon: <IconBook />,
      label: 'Assignment',
      title: 'Assignment',
      disabledReason: '과제 기능은 준비 중입니다.',
      path: null,
      disabled: true,
      expandable: true,
      children: [
        { id: 'assignment-log', title: 'Assignment Log', path: PATH.STUDENT.ASSIGNMENT.LOG },
        { id: 'assignment-setup', title: 'Assignment Setting', path: PATH.STUDENT.ASSIGNMENT.SETUP },
      ],
    },
    {
      id: 'classroom',
      Icon: <IconCheckSquareBroken />,
      label: 'Classroom',
      title: 'Classroom',
      subtitle: '(예정/진행중)',
      path: null,
      lazyExpandChildren: true,
      lazyResourceKey: 'expandedLesson',
      activePathPrefix: [PATH.STUDENT.CLASSROOM.INDEX],
      children: [],
    },
  ],
  [USER_ROLE.PARENT]: [
    { id: 'home', Icon: <IconHome />, label: 'HOME', title: 'HOME', path: PATH.PARENT.HOME },
    {
      id: 'my-class',
      Icon: <IconCheckSquareBroken />,
      label: 'My Class',
      title: 'My Class',
      path: PATH.PARENT.MY_CLASS,
    },
    { id: 'attendance', Icon: <IconCalendar />, label: 'Attendance', title: 'Attendance', path: PATH.PARENT.ATTENDANCE.INDEX },
  ],
};
